document.addEventListener('click', function(e){
  const toggle=e.target.closest('[data-menu-toggle]');
  if(toggle){ document.querySelector('[data-nav]')?.classList.toggle('is-open'); }

  const galleryArrow=e.target.closest('[data-card-gallery-prev],[data-card-gallery-next]');
  if(galleryArrow){
    const card=galleryArrow.closest('[data-product-card]');
    const images=Array.from(card?.querySelectorAll('[data-card-image]') || []);
    if(images.length){
      const current=Math.max(0,images.findIndex(image => !image.hidden));
      const direction=galleryArrow.matches('[data-card-gallery-next]') ? 1 : -1;
      const next=(current+direction+images.length)%images.length;
      images.forEach((image,index) => { image.hidden=index !== next; });
    }
  }

  const thumb=e.target.closest('[data-thumbnail]');
  if(thumb){
    const gallery=thumb.closest('[data-product-gallery]');
    const main=gallery?.querySelector('[data-main-product-image]');
    const full=thumb.getAttribute('data-full-image');
    const zoom=thumb.getAttribute('data-zoom-image');
    if(main && full){
      main.src=full;
      main.removeAttribute('srcset');
      const opener=gallery.querySelector('[data-product-zoom-open]');
      if(opener && zoom) opener.setAttribute('data-product-zoom-image', zoom);
      gallery.querySelectorAll('[data-thumbnail]').forEach(btn=>btn.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
  }
});

// Full-screen product image viewer with magnifying controls
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const opener = gallery.querySelector('[data-product-zoom-open]');
    const lightbox = gallery.querySelector('[data-product-lightbox]');
    const image = lightbox?.querySelector('[data-product-lightbox-image]');
    const canvas = lightbox?.querySelector('[data-product-zoom-canvas]');
    const resetButton = lightbox?.querySelector('[data-product-zoom-reset]');
    if(!opener || !lightbox || !image || !canvas) return;
    let scale = 1;

    function applyScale(){
      const zoomed = scale > 1;
      image.style.width = zoomed ? `${scale * 100}%` : 'auto';
      image.style.maxWidth = zoomed ? 'none' : '100%';
      image.style.maxHeight = zoomed ? 'none' : '100%';
      canvas.classList.toggle('is-zoomed', zoomed);
      if(resetButton) resetButton.textContent = `${Math.round(scale * 100)}%`;
    }
    function setScale(value){ scale = Math.min(4, Math.max(1, value)); applyScale(); }
    function openViewer(){
      image.src = opener.getAttribute('data-product-zoom-image') || gallery.querySelector('[data-main-product-image]')?.src || '';
      setScale(1); lightbox.hidden = false; lightbox.setAttribute('aria-hidden','false');
      document.body.classList.add('product-lightbox-open');
      lightbox.querySelector('[data-product-zoom-in]')?.focus();
    }
    function closeViewer(){
      lightbox.hidden = true; lightbox.setAttribute('aria-hidden','true');
      document.body.classList.remove('product-lightbox-open'); opener.focus();
    }
    opener.addEventListener('click', openViewer);
    lightbox.querySelectorAll('[data-product-zoom-close]').forEach(button => button.addEventListener('click', closeViewer));
    lightbox.querySelector('[data-product-zoom-in]')?.addEventListener('click', () => setScale(scale + .5));
    lightbox.querySelector('[data-product-zoom-out]')?.addEventListener('click', () => setScale(scale - .5));
    resetButton?.addEventListener('click', () => setScale(1));
    canvas.addEventListener('dblclick', () => setScale(scale === 1 ? 2 : 1));
    lightbox.addEventListener('keydown', event => {
      if(event.key === 'Escape') closeViewer();
      if(event.key === '+' || event.key === '=') setScale(scale + .5);
      if(event.key === '-') setScale(scale - .5);
    });
  });
});

// Gentle one-time reveal for standalone collection banners
document.addEventListener('DOMContentLoaded', function(){
  const banners = Array.from(document.querySelectorAll('[data-animated-collection-banner]'));
  if(!banners.length) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduceMotion || !('IntersectionObserver' in window)){
    banners.forEach(banner => banner.classList.add('is-visible'));
    return;
  }
  banners.forEach(banner => banner.classList.add('has-animate'));
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting){ entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    });
  }, {threshold:.18});
  banners.forEach(banner => observer.observe(banner));
});

document.addEventListener('change', function(e){
  if(!e.target.matches('[data-option-value]')) return;
  const productPage = e.target.closest('[data-product-page]');
  if(!productPage) return;

  const variantsScript = productPage.querySelector('[data-variants-json]');
  const idInput = productPage.querySelector('[data-variant-id]');
  const button = productPage.querySelector('[data-add-to-cart]');
  const price = productPage.querySelector('[data-product-price]');
  if(!variantsScript || !idInput || !button) return;

  const variants = JSON.parse(variantsScript.textContent);
  const selectedOptions = Array.from(productPage.querySelectorAll('[data-option-value]:checked')).map(input => input.value);
  const matchedVariant = variants.find(variant => {
    return variant.options.every((option, index) => option === selectedOptions[index]);
  });

  if(!matchedVariant){
    button.disabled = true;
    button.textContent = 'Unavailable';
    return;
  }

  idInput.value = matchedVariant.id;
  button.disabled = !matchedVariant.available;
  button.textContent = matchedVariant.available ? 'Add to Bag' : 'Sold Out';

  if(price && window.Shopify && typeof Shopify.formatMoney === 'function'){
    price.textContent = Shopify.formatMoney(matchedVariant.price);
  }

  if(matchedVariant.featured_media){
    const thumbnail=productPage.querySelector(`[data-thumbnail][data-media-id="${matchedVariant.featured_media.id}"]`);
    thumbnail?.click();
  } else if(matchedVariant.featured_image?.src){
    const gallery=productPage.querySelector('[data-product-gallery]');
    const main=gallery?.querySelector('[data-main-product-image]');
    if(main){ main.src=matchedVariant.featured_image.src; main.removeAttribute('srcset'); }
  }
});

function updateProductOptionAvailability(productPage){
  const variantsScript = productPage.querySelector('[data-variants-json]');
  if(!variantsScript) return;

  let variants;
  try { variants = JSON.parse(variantsScript.textContent); } catch(error) { return; }

  const groups = Array.from(productPage.querySelectorAll('[data-option-index]'));
  const selected = groups.map(group => group.querySelector('[data-option-value]:checked')?.value || null);

  groups.forEach((group, groupIndex) => {
    group.querySelectorAll('[data-option-value]').forEach(input => {
      const candidate = input.value;
      const isAvailable = variants.some(variant => {
        if(!variant.available || variant.options[groupIndex] !== candidate) return false;
        return variant.options.every((option, optionIndex) => {
          if(optionIndex === groupIndex) return true;
          return !selected[optionIndex] || selected[optionIndex] === option;
        });
      });

      input.disabled = !isAvailable;
      const label = group.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if(label){
        label.classList.toggle('is-unavailable', !isAvailable);
        label.setAttribute('aria-disabled', String(!isAvailable));
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-product-page]').forEach(updateProductOptionAvailability);

  document.querySelectorAll('[data-product-recommendations]').forEach(container => {
    const url = container.dataset.recommendationsUrl;
    if(!url) return;
    fetch(url)
      .then(response => response.text())
      .then(html => {
        if(html.trim()) container.innerHTML = html;
      })
      .catch(() => {});
  });
});

// Accessible, touch-friendly homepage banner carousel
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-banner-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    const pause = carousel.querySelector('[data-carousel-pause]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0, timer = null, paused = reduceMotion, touchStart = 0;
    const delay = Math.max(3000, Number(carousel.dataset.autoplay) || 5000);

    function show(next, userInitiated){
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a, button').forEach(item => item.tabIndex = active ? 0 : -1);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', String(i === index));
      });
      if(userInitiated) restart();
    }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function start(){ if(!paused && !reduceMotion){ stop(); timer = setInterval(() => show(index + 1, false), delay); } }
    function restart(){ stop(); start(); }

    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => show(index - 1, true));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(index + 1, true));
    dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.carouselDot), true)));
    pause?.addEventListener('click', () => {
      paused = !paused; pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Play banner rotation' : 'Pause banner rotation');
      paused ? stop() : start();
    });
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', event => { if(!carousel.contains(event.relatedTarget)) start(); });
    carousel.addEventListener('keydown', event => {
      if(event.key === 'ArrowLeft') show(index - 1, true);
      if(event.key === 'ArrowRight') show(index + 1, true);
    });
    carousel.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; stop(); }, {passive:true});
    carousel.addEventListener('touchend', event => {
      const distance = event.changedTouches[0].clientX - touchStart;
      if(Math.abs(distance) > 45) show(index + (distance < 0 ? 1 : -1), true); else start();
    }, {passive:true});
    show(0, false); start();
  });
});

document.addEventListener('change', function(event){
  if(!event.target.matches('[data-option-value]')) return;
  const page = event.target.closest('[data-product-page]');
  if(page) updateProductOptionAvailability(page);
});

// Quick Look modal and AJAX add-to-cart
(function(){
  let activeModal = null;
  let lastQuickLookTrigger = null;
  let originalParent = null;
  let originalNextSibling = null;

  function openQuickLook(id, trigger){
    const modal = document.getElementById(id);
    if(!modal) return;
    if(activeModal && activeModal !== modal) closeQuickLook(activeModal, false);

    lastQuickLookTrigger = trigger || null;
    originalParent = modal.parentNode;
    originalNextSibling = modal.nextSibling;
    document.body.appendChild(modal);
    modal.hidden = false;
    activeModal = modal;
    document.body.classList.add('quick-look-open');

    const dialog = modal.querySelector('.quick-look__dialog');
    if(dialog) dialog.scrollTop = 0;
    requestAnimationFrame(() => modal.querySelector('[data-quick-look-close]')?.focus({preventScroll:true}));
  }

  function restoreModal(modal){
    if(!modal || !originalParent) return;
    if(originalNextSibling && originalNextSibling.parentNode === originalParent){
      originalParent.insertBefore(modal, originalNextSibling);
    }else{
      originalParent.appendChild(modal);
    }
  }

  function closeQuickLook(modal, restoreFocus = true){
    if(!modal) return;
    modal.hidden = true;
    document.body.classList.remove('quick-look-open');
    restoreModal(modal);
    activeModal = null;
    originalParent = null;
    originalNextSibling = null;
    const trigger = lastQuickLookTrigger;
    lastQuickLookTrigger = null;
    if(restoreFocus) requestAnimationFrame(() => trigger?.focus({preventScroll:true}));
  }

  document.addEventListener('click', function(event){
    const opener = event.target.closest('[data-quick-look-open]');
    if(opener){
      event.preventDefault();
      event.stopPropagation();
      openQuickLook(opener.getAttribute('data-quick-look-open'), opener);
      return;
    }

    const closer = event.target.closest('[data-quick-look-close]');
    if(closer){
      event.preventDefault();
      event.stopPropagation();
      closeQuickLook(closer.closest('[data-quick-look]'));
      return;
    }

    const variantButton = event.target.closest('[data-quick-look-variant-button]');
    if(variantButton && !variantButton.disabled){
      event.preventDefault();
      const modal = variantButton.closest('[data-quick-look]');
      const form = variantButton.closest('[data-quick-look-form]');
      const idInput = form?.querySelector('[data-quick-look-variant-id]');
      const price = modal?.querySelector('[data-quick-look-price]');
      const addButton = form?.querySelector('[data-quick-look-add]');

      modal?.querySelectorAll('[data-quick-look-variant-button]').forEach(button => {
        const selected = button === variantButton;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      if(idInput) idInput.value = variantButton.dataset.variantId || '';
      if(price && variantButton.dataset.price) price.textContent = variantButton.dataset.price;
      if(addButton){ addButton.disabled = false; addButton.textContent = 'Add to Bag'; }
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape' && activeModal) closeQuickLook(activeModal);
  });

  document.addEventListener('submit', async function(event){
    const form = event.target.closest('[data-quick-look-form]');
    if(!form) return;
    event.preventDefault();

    const modal = form.closest('[data-quick-look]');
    const button = form.querySelector('[data-quick-look-add]');
    const status = form.querySelector('[data-quick-look-status]');
    const variantInput = form.querySelector('[data-quick-look-variant-id]');
    if(!button || !variantInput?.value) return;

    const originalText = button.textContent.trim() || 'Add to Bag';
    button.disabled = true;
    button.textContent = 'Adding…';
    if(status){ status.textContent = ''; status.classList.remove('is-error'); }

    try{
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: new FormData(form)
      });
      const result = await response.json();
      if(!response.ok) throw new Error(result.description || 'This item could not be added.');

      button.textContent = 'Added ✓';
      if(status) status.textContent = 'Added to your bag.';
      await window.Shop777Cart?.refresh();
      closeQuickLook(modal, false);
      window.Shop777Cart?.open(button);
    }catch(error){
      button.textContent = originalText;
      button.disabled = false;
      if(status){ status.textContent = error.message; status.classList.add('is-error'); }
    }
  });
})();


// Predictive product search with typo-tolerant closest matches
(function(){
  const overlay = document.querySelector('[data-predictive-search]');
  if(!overlay) return;
  const input = overlay.querySelector('[data-predictive-search-input]');
  const results = overlay.querySelector('[data-predictive-search-results]');
  const status = overlay.querySelector('[data-predictive-search-status]');
  let timer = null;
  let productCache = null;
  let controller = null;

  function escapeHtml(value){
    return String(value || '').replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
  }
  function money(cents){
    if(window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format((Number(cents)||0)/100);
  }
  function openSearch(){
    overlay.hidden = false;
    document.body.classList.add('search-open');
    requestAnimationFrame(() => input.focus());
  }
  function closeSearch(){
    overlay.hidden = true;
    document.body.classList.remove('search-open');
  }
  function render(items, query, fuzzy){
    if(!items.length){
      results.innerHTML = '<p class="predictive-search__empty">No products found. Try another word or browse all products.</p><a class="btn outline" href="/collections/all">Shop All Products</a>';
      status.textContent = 'No matching products found.';
      return;
    }
    status.textContent = fuzzy ? `Closest matches for “${query}”` : `${items.length} product match${items.length === 1 ? '' : 'es'}`;
    results.innerHTML = items.slice(0,8).map(product => {
      const image = product.image || product.featured_image || product.featured_image?.url || '';
      const url = product.url || ('/products/' + product.handle);
      let price = product.price;
      if(typeof price === 'string' && price.includes('.')) price = Math.round(parseFloat(price) * 100);
      return `<a class="predictive-search__item" href="${escapeHtml(url)}">
        <span class="predictive-search__image">${image ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">` : ''}</span>
        <span class="predictive-search__copy"><strong>${escapeHtml(product.title)}</strong><small>${money(price)}</small></span>
      </a>`;
    }).join('') + `<a class="predictive-search__view-all" href="/search?type=product&q=${encodeURIComponent(query)}">View all search results</a>`;
  }
  function normalize(text){ return String(text || '').toLowerCase().replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim(); }
  function levenshtein(a,b){
    a=normalize(a); b=normalize(b);
    const row=Array.from({length:b.length+1},(_,i)=>i);
    for(let i=1;i<=a.length;i++){
      let prev=row[0]; row[0]=i;
      for(let j=1;j<=b.length;j++){
        const old=row[j];
        row[j]=Math.min(row[j]+1,row[j-1]+1,prev+(a[i-1]===b[j-1]?0:1));
        prev=old;
      }
    }
    return row[b.length];
  }
  function fuzzyScore(product, query){
    const q=normalize(query); const title=normalize(product.title); const words=title.split(' ');
    if(title.includes(q)) return -10;
    const distances=[levenshtein(q,title),...words.map(word=>levenshtein(q,word))];
    return Math.min(...distances) / Math.max(1,q.length);
  }
  async function fuzzySearch(query){
    if(!productCache){
      const response = await fetch('/products.json?limit=250', {headers:{'Accept':'application/json'}});
      if(!response.ok) return [];
      productCache = (await response.json()).products || [];
    }
    return productCache.map(product=>({product,score:fuzzyScore(product,query)}))
      .filter(entry=>entry.score <= .72)
      .sort((a,b)=>a.score-b.score)
      .slice(0,8).map(entry=>entry.product);
  }
  async function search(query){
    controller?.abort(); controller = new AbortController();
    status.textContent = 'Searching…'; results.innerHTML = '';
    try{
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
      const response = await fetch(url,{signal:controller.signal,headers:{'Accept':'application/json'}});
      const data = response.ok ? await response.json() : null;
      const products = data?.resources?.results?.products || [];
      if(products.length){ render(products,query,false); return; }
      const fuzzy = await fuzzySearch(query);
      render(fuzzy,query,true);
    }catch(error){
      if(error.name !== 'AbortError'){
        const fuzzy = await fuzzySearch(query).catch(()=>[]);
        render(fuzzy,query,true);
      }
    }
  }
  document.addEventListener('click', event => {
    if(event.target.closest('[data-search-open]')) openSearch();
    if(event.target.closest('[data-search-close]')) closeSearch();
  });
  document.addEventListener('keydown', event => { if(event.key === 'Escape' && !overlay.hidden) closeSearch(); });
  input.addEventListener('input', () => {
    clearTimeout(timer); const query=input.value.trim();
    if(query.length < 2){ results.innerHTML=''; status.textContent='Type at least 2 letters to see products.'; return; }
    timer=setTimeout(()=>search(query),180);
  });

  const form = overlay.querySelector('.predictive-search__form');
  form?.addEventListener('submit', async event => {
    const query = input.value.trim();
    if(query.length < 2) return;
    event.preventDefault();
    status.textContent = 'Finding the best matches…';
    try{
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
      const response = await fetch(url,{headers:{'Accept':'application/json'}});
      const data = response.ok ? await response.json() : null;
      const exact = data?.resources?.results?.products || [];
      if(exact.length){ window.location.href = `/search?type=product&q=${encodeURIComponent(query)}`; return; }
      const fuzzy = await fuzzySearch(query);
      if(fuzzy.length){
        const bestTitle = fuzzy[0].title || query;
        window.location.href = `/search?type=product&q=${encodeURIComponent(bestTitle)}&original_q=${encodeURIComponent(query)}`;
        return;
      }
      window.location.href = `/search?type=product&q=${encodeURIComponent(query)}`;
    }catch(error){
      window.location.href = `/search?type=product&q=${encodeURIComponent(query)}`;
    }
  });
})();


// Persistent slide-out shopping bag
(function(){
  const drawer = document.querySelector('[data-cart-drawer]');
  if(!drawer) return;
  const itemsNode = drawer.querySelector('[data-cart-drawer-items]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const totalNode = drawer.querySelector('[data-cart-drawer-total]');
  const countNode = drawer.querySelector('[data-cart-drawer-count]');
  const shippingNode = drawer.querySelector('[data-cart-drawer-shipping]');
  let lastTrigger = null;

  function escapeHtml(value){ return String(value || '').replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch])); }
  function money(cents){
    if(window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format((Number(cents)||0)/100);
  }
  function setCounts(count){
    document.querySelectorAll('.cart-count').forEach(node => {
      node.textContent = count;
      node.classList.toggle('is-empty', count === 0);
    });
    if(countNode) countNode.textContent = `(${count})`;
  }
  function shippingMarkup(total){
    const threshold = 7500;
    const remaining = Math.max(0, threshold-total);
    const progress = Math.min(100, Math.round(total/threshold*100));
    const message = remaining === 0 ? '<strong>You unlocked FREE shipping! 🎉</strong>' : `You’re <strong>${money(remaining)}</strong> away from FREE shipping`;
    return `<p>${message}</p><div class="cart-drawer__shipping-track"><span style="width:${progress}%"></span></div><small>Free U.S. shipping on orders $75+</small>`;
  }
  function render(cart){
    setCounts(cart.item_count);
    shippingNode.innerHTML = shippingMarkup(cart.total_price);
    if(!cart.items.length){
      itemsNode.innerHTML = '<div class="cart-drawer__empty"><p>Your bag is ready for something cute.</p><a class="btn primary full" href="/collections/all">Shop All Products</a></div>';
      footer.hidden = true;
      return;
    }
    itemsNode.innerHTML = cart.items.map((item,index) => `
      <article class="cart-drawer__item" data-cart-line="${index+1}">
        <a class="cart-drawer__image" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}</a>
        <div class="cart-drawer__details">
          <a class="cart-drawer__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <div class="cart-drawer__controls">
            <button type="button" data-cart-quantity="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-quantity="${item.quantity+1}" aria-label="Increase quantity">+</button>
            <button class="cart-drawer__remove" type="button" data-cart-quantity="0">Remove</button>
          </div>
        </div>
        <strong class="cart-drawer__price">${money(item.final_line_price)}</strong>
      </article>`).join('');
    totalNode.textContent = money(cart.total_price);
    footer.hidden = false;
  }
  async function refresh(){
    const response = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    const cart = await response.json();
    render(cart);
    return cart;
  }
  async function change(line,quantity){
    itemsNode.classList.add('is-updating');
    try{
      const response = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})});
      const cart = await response.json();
      render(cart);
    }finally{ itemsNode.classList.remove('is-updating'); }
  }
  async function open(trigger){
    lastTrigger = trigger || null;
    drawer.hidden = false;
    document.body.classList.add('cart-drawer-open');
    await refresh().catch(()=>{});
    drawer.querySelector('[data-cart-drawer-close]')?.focus();
  }
  function close(){
    drawer.hidden = true;
    document.body.classList.remove('cart-drawer-open');
    lastTrigger?.focus();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cart-drawer-open]');
    if(opener){ event.preventDefault(); open(opener); return; }
    if(event.target.closest('[data-cart-drawer-close]')){ event.preventDefault(); close(); return; }
    const quantityButton = event.target.closest('[data-cart-quantity]');
    if(quantityButton){
      const item = quantityButton.closest('[data-cart-line]');
      if(item) change(Number(item.dataset.cartLine), Number(quantityButton.dataset.cartQuantity));
    }
  });
  document.addEventListener('keydown', event => { if(event.key === 'Escape' && !drawer.hidden) close(); });
  window.Shop777Cart = {open, refresh};
})();

// AJAX add from the main product page, then open the bag
(function(){
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if(!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-add-to-cart]');
    const original = button?.textContent;
    if(button){ button.disabled=true; button.textContent='Adding…'; }
    try{
      const response = await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)});
      const data = await response.json();
      if(!response.ok) throw new Error(data.description || 'This item could not be added.');
      if(button) button.textContent='Added ✓';
      await window.Shop777Cart?.refresh();
      window.Shop777Cart?.open(button);
    }catch(error){
      if(button){ button.disabled=false; button.textContent=original || 'Add to Bag'; }
      alert(error.message);
      return;
    }
    setTimeout(()=>{ if(button){ button.disabled=false; button.textContent=original || 'Add to Bag'; } },1200);
  });
})();

// Closest-match fallback on the full search page
(function(){
  const container = document.querySelector('[data-search-page-closest]');
  const page = document.querySelector('[data-search-page]');
  if(!container || !page) return;
  const query = page.dataset.searchQuery || '';
  const normalize = text => String(text||'').toLowerCase().replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
  function distance(a,b){
    a=normalize(a); b=normalize(b); const row=Array.from({length:b.length+1},(_,i)=>i);
    for(let i=1;i<=a.length;i++){ let prev=row[0]; row[0]=i; for(let j=1;j<=b.length;j++){ const old=row[j]; row[j]=Math.min(row[j]+1,row[j-1]+1,prev+(a[i-1]===b[j-1]?0:1)); prev=old; } }
    return row[b.length];
  }
  fetch('/products.json?limit=250',{headers:{'Accept':'application/json'}}).then(r=>r.json()).then(data=>{
    const products=(data.products||[]).map(product=>{
      const words=normalize(product.title).split(' '); const score=Math.min(distance(query,product.title),...words.map(word=>distance(query,word)))/Math.max(1,normalize(query).length);
      return {product,score};
    }).filter(x=>x.score<=.8).sort((a,b)=>a.score-b.score).slice(0,12).map(x=>x.product);
    if(!products.length){ container.innerHTML='<p class="search-page__summary">We couldn’t find a close match. Try a shorter word or browse all products.</p><a class="btn primary" href="/collections/all">Shop All Products</a>'; return; }
    container.innerHTML=`<p class="search-page__summary">Closest matches for “${query.replace(/[<>&]/g,'')}”</p><div class="search-fallback-grid">${products.map(product=>`<a class="search-fallback-card" href="/products/${product.handle}"><span>${product.images?.[0]?.src ? `<img src="${product.images[0].src}&width=500" alt="" loading="lazy">` : ''}</span><strong>${product.title}</strong><small>${new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(Number(product.variants?.[0]?.price||0))}</small></a>`).join('')}</div>`;
  }).catch(()=>{ container.innerHTML='<p class="search-page__summary">Try another spelling or browse all products.</p><a class="btn primary" href="/collections/all">Shop All Products</a>'; });
})();
// Collection filters and sorting
(function(){
  const form=document.querySelector('[data-collection-filters]'); if(!form) return;
  const toggle=form.querySelector('[data-filter-toggle]'); const panel=form.querySelector('[data-filter-panel]');
  toggle?.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));panel.hidden=!open;});
  form.querySelector('[data-sort-select]')?.addEventListener('change',()=>form.submit());
})();

// First-visit email offer
(function(){
  const popup=document.querySelector('[data-welcome-popup]'); if(!popup) return;
  const storageKey='shop777-welcome-offer-v1'; let lastSeen=0;
  try{lastSeen=Number(localStorage.getItem(storageKey)||0)}catch(e){}
  const submitted=popup.querySelector('.welcome-popup__success,.welcome-popup__error');
  function open(){popup.hidden=false;document.body.classList.add('welcome-popup-open');popup.querySelector('.welcome-popup__dialog')?.focus();try{localStorage.setItem(storageKey,String(Date.now()))}catch(e){}}
  function close(){popup.hidden=true;document.body.classList.remove('welcome-popup-open')}
  popup.querySelectorAll('[data-welcome-close]').forEach(button=>button.addEventListener('click',close));
  popup.querySelector('[data-copy-code]')?.addEventListener('click',async event=>{try{await navigator.clipboard.writeText('WELCOME20');event.currentTarget.textContent='COPIED!'}catch(e){}});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!popup.hidden)close()});
  if(submitted) setTimeout(open,250); else if(Date.now()-lastSeen>14*24*60*60*1000) setTimeout(open,3500);
})();
